module.exports = __webpack_public_path__ + "img/1.877fb271.webp";